module.exports = __webpack_public_path__ + "assets/Switch.bdd46ce5.svg";